
import { translate } from "app/filters/i18nFilter";
import useTechnologiesQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useTechnologiesQuery";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { TechnologiesContent } from "app/pages/sales-intelligence/pages/company-analysis/containers/technologies/TechnologiesContent/TechnologiesContent";

const TechnologiesSectionContent = ({ isWebsiteAnalysis }: { isWebsiteAnalysis?: boolean }) => {
    const { data, isLoading, isFetched } = useTechnologiesQuery({ isWebsiteAnalysis });
    const isEmpty = (!data || data.length === 0) && isFetched;

    return (
        <Card
            isEmpty={isEmpty}
            dataAutomation="technologies-tab"
            renderContent={() => (
                <TechnologiesContent
                    technologies={data}
                    isLoading={isLoading}
                    isWebsiteAnalysis={isWebsiteAnalysis}
                />
            )}
            header={
                <CardHeader
                    title={translate("si.company-analysis.technologies.card.header")}
                    infoTooltip={translate("si.company-analysis.technologies.card.header.info-tooltip")}
                />
            }
        />
    );
};

export default TechnologiesSectionContent;
